import { resetAnalytics } from "./analytics";
import { SESSION_KEY_LOGIN_INCREMENTED } from "./hooks/use-login-counter";

// localStorage keys that survive logout / session expiry: UI preferences,
// dismissals, and tour progress. Everything else (token, user, cached state)
// is cleared. This is the union of what every logout path used to preserve
// individually — keeping them in one list is the whole point of this module.
const isPreservedKey = (key: string): boolean =>
  key === "sidebar_expanded" ||
  key === "mbr_new_report_notification_dismissed" ||
  key === "brief_tour_completed_v1" ||
  key === "welcome_tour_dismissed_v1" ||
  key === "tutorial_narration_enabled" ||
  key === "calendar_options_v2" ||
  key === "dashboard_revenue_horizon" ||
  key.startsWith("feature_announcement_dismissed_") ||
  key.startsWith("first_booking_congrats_dismissed_") ||
  key.startsWith("marketing_tutorial_login_count_") ||
  key.startsWith("app_tutorial_completed_") ||
  key.startsWith("tutorial_login_count_") ||
  key.startsWith("autumn_");

/** Clear auth/session state while preserving UI preferences (see isPreservedKey). */
export const clearSession = (): void => {
  const preserved: Record<string, string> = {};
  Object.keys(localStorage).forEach((key) => {
    if (isPreservedKey(key)) preserved[key] = localStorage.getItem(key) || "";
  });

  localStorage.clear();
  sessionStorage.removeItem(SESSION_KEY_LOGIN_INCREMENTED);

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

/** Log the user out: reset analytics, clear the session, redirect. */
export const logout = (redirectTo = "/login"): void => {
  resetAnalytics();
  clearSession();
  window.location.href = redirectTo;
};
